import ScientificAnalysisFilterPanelPatientage from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel-patientage/scientific-analysis-filter-panel-patientage'
import { ScientificAnalysisComparatorType, ScientificAnalysisConditionTypeEnum } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { ScientificAnalysisCondition, ScientificAnalysisConditionFieldGroup } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import moment from 'moment'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { DateUtils } from '@/shared/util/date-utils'

@Component
export default class ScientificAnalysisSummaryDetail extends Vue {
    @Prop() groups!: ScientificAnalysisConditionFieldGroup[]

    isSingleValue(condition: ScientificAnalysisCondition): boolean {
        return !this.isRangeValue(condition)
    }

    isRangeValue(condition: ScientificAnalysisCondition): boolean {
        return condition.comparisonType.comparatorType === ScientificAnalysisComparatorType.IN_RANGE
    }

    isPatientAge(condition: ScientificAnalysisCondition): boolean {
        return (!!condition.metaInfo &&
            condition.metaInfo.length > 0 &&
            condition.metaInfo[0] === ScientificAnalysisFilterPanelPatientage.PATIENT_AGE_METAINFO)
    }

    isDate(condition: ScientificAnalysisCondition): boolean {
        return (condition.comparisonType.conditionType === ScientificAnalysisConditionTypeEnum.DATE) ||
            (condition.comparisonType.conditionType === ScientificAnalysisConditionTypeEnum.DATETIME)
    }

    isRelatedEntity(condition: ScientificAnalysisCondition): boolean {
        return !!condition.comparisonType.additionalInfo && condition.comparisonType.additionalInfo.length > 0
    }

    isBooleanCondition(condition: ScientificAnalysisCondition): boolean {
        return condition.comparisonType.conditionType === ScientificAnalysisConditionTypeEnum.BOOLEAN
    }

    getBooleanValueTranslated(condition: ScientificAnalysisCondition): string {
        if ((condition.value as string).toUpperCase() === 'TRUE') {
            return this.$tc('scientificAnalysis.filterForm.booleanTrue')
        } else {
            return this.$tc('scientificAnalysis.filterForm.booleanFalse')
        }
    }

    getLocaleDatePattern(condition: ScientificAnalysisCondition, value: string): string {
        if (value && value.length > 0) {
            const isDateTime = condition.comparisonType.conditionType === ScientificAnalysisConditionTypeEnum.DATETIME
            if (isDateTime) {
                return moment(value).format(DateUtils.localeDateTimePattern)
            } else {
                return moment(value).format(DateUtils.localeDatePattern)
            }
        }
        return ''
    }

    getLocalizedComparisonName(comparison: ScientificAnalysisComparatorType): string {
        return this.$t(`scientificAnalysis.condition.${comparison}`) as string
    }

    getPatientAgeValueFrom(condition: ScientificAnalysisCondition):string {
        return `${(condition.value as string).substr(2)} ${condition.metaInfo ? condition.metaInfo[1] : ''}`
    }

    getPatientAgeValueTo(condition: ScientificAnalysisCondition): string {
        return `${condition.valueTo} ${condition.metaInfo ? condition.metaInfo[1] : ''}`
    }
}
